import React, { useEffect, useState, useContext, useRef } from 'react';
import { Modal, Table, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './Styles.css';

function Consumption({ SN, Combinations }) {
    const { t } = useTranslation();


    const handleClick = () => {
        Modal.info({
            maskClosable: true,
            width: "70%",
            icon: null,
            title: t("Consumption"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase == 2 ? "(A)" : r.Phase == 3 ? "(B)" : r.Phase == 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("Daily Load (kWh)"), dataIndex: "EDayLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Monthly Load (kWh)"), dataIndex: "EMonthLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Yearly Load (kWh)"), dataIndex: "EYearLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Total Load (kWh)"), dataIndex: "ETotalLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Daily Smart Load (kWh)"), dataIndex: "EDaySmartLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Monthly Smart Load (kWh)"), dataIndex: "EMonthSmartLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Yearly Smart Load (kWh)"), dataIndex: "EYearSmartLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Total Smart Load (kWh)"), dataIndex: "ETotalSmartLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Daily Grid-Side Load (kWh)"), dataIndex: "EDayGridLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Monthly Grid-Side Load (kWh)"), dataIndex: "EMonthGridLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Yearly Grid-Side Load (kWh)"), dataIndex: "EYearGridLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Total Grid-Side Load (kWh)"), dataIndex: "ETotalGridLoad",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},

                ]}
                summary={(data) => {
                    if (!data || data.length < 2) {
                        return null;
                    }
                    let EDayLoad = 0;
                    let EMonthLoad = 0;
                    let EYearLoad = 0;
                    let ETotalLoad = 0;
                    let EDaySmartLoad = 0;
                    let EMonthSmartLoad = 0;
                    let EYearSmartLoad = 0;
                    let ETotalSmartLoad = 0;
                    let EDayGridLoad = 0;
                    let EMonthGridLoad = 0;
                    let EYearGridLoad = 0;
                    let ETotalGridLoad = 0;
                    data.forEach((item, index) => {
                        if (item.EDayLoad != null ) {
                            let v = parseInt(item.EDayLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EDayLoad += v * 0.01;
                        }
                        if (item.EMonthLoad != null ) {
                            let v = parseInt(item.EMonthLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EMonthLoad += v * 0.01;
                        }
                        if (item.EYearLoad != null ) {
                            let v = parseInt(item.EYearLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EYearLoad += v * 0.01;
                        }
                        if (item.ETotalLoad != null ) {
                            let v = parseInt(item.ETotalLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            ETotalLoad += v * 0.01;
                        }
                        if (item.EDaySmartLoad != null ) {
                            let v = parseInt(item.EDaySmartLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EDaySmartLoad += v * 0.01;
                        }
                        if (item.EMonthSmartLoad != null ) {
                            let v = parseInt(item.EMonthSmartLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EMonthSmartLoad += v * 0.01;
                        }
                        if (item.EYearSmartLoad != null ) {
                            let v = parseInt(item.EYearSmartLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EYearSmartLoad += v * 0.01;
                        }
                        if (item.ETotalSmartLoad != null ) {
                            let v = parseInt(item.ETotalSmartLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            ETotalSmartLoad += v * 0.01;
                        }
                        if (item.EDayGridLoad != null ) {
                            let v = parseInt(item.EDayGridLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EDayGridLoad += v * 0.01;
                        }
                        if (item.EMonthGridLoad != null ) {
                            let v = parseInt(item.EMonthGridLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EMonthGridLoad += v * 0.01;
                        }
                        if (item.EYearGridLoad != null ) {
                            let v = parseInt(item.EYearGridLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EYearGridLoad += v * 0.01;
                        }
                        if (item.ETotalGridLoad != null ) {
                            let v = parseInt(item.ETotalGridLoad);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            ETotalGridLoad += v * 0.01;
                        }
                    });
                    return (
                        <>
                            <Table.Summary.Row style={{fontWeight:"bold"}}>
                                <Table.Summary.Cell index={0} colSpan={2} align='right'>{t("Subtotal")}</Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>{EDayLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{EMonthLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{EYearLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{ETotalLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={5}>{EDaySmartLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={6}>{EMonthSmartLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={7}>{EYearSmartLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={8}>{ETotalSmartLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={9}>{EDayGridLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={10}>{EMonthGridLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={11}>{EYearGridLoad.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={12}>{ETotalGridLoad.toFixed(2)}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
                dataSource={Combinations}
                scroll={{ x: true }}
            />),
            onOk() {
            },
        });
    };

    let EDayLoad = 0;
    let ETotalLoad = 0;
    let count = Combinations?.length || 0;

    if (Combinations != null) {
        Combinations.forEach((item, index) => {
            if (item.EDayLoad != null ) {
                let v = parseInt(item.EDayLoad);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                EDayLoad += v * 0.01;
            }
            if (item.EDaySmartLoad != null ) {
                let v = parseInt(item.EDaySmartLoad);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                EDayLoad += v * 0.01;
            }
            if (item.EDayGridLoad != null ) {
                let v = parseInt(item.EDayGridLoad);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                EDayLoad += v * 0.01;
            }
            if (item.ETotalLoad != null ) {
                let v = parseInt(item.ETotalLoad);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                ETotalLoad += v * 0.01;
            }
            if (item.ETotalSmartLoad != null ) {
                let v = parseInt(item.ETotalSmartLoad);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                ETotalLoad += v * 0.01;
            }
            if (item.ETotalGridLoad != null ) {
                let v = parseInt(item.ETotalGridLoad);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                ETotalLoad += v * 0.01;
            }
        });
    }
    

    return (<div className="combination-stats-block">
        <div className="title" style={{ backgroundColor: '#6fad92' }}>
            {t('Consumption')}
            <Button ghost size='small' shape="round" onClick={handleClick}>{t("Details")}</Button>
        </div>
        <div className="content" >
            <div className="left">
                <img src="images/inverter/load.png" alt={t('Load')}></img>
            </div>
            <div className="right">
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {EDayLoad.toFixed(2)} {t('kWh')}
                    {count > 1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Load')}</div>
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {ETotalLoad.toFixed(2)} {t('kWh')}
                    {count > 1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Load')}</div>
            </div>
        </div>
    </div>);
}

export default Consumption;
